<template>
  <el-dialog title="设置发货时效模板" :visible.sync="visible" width="700px" @close="handleClose">
    <el-form :rules="rules" :model="form" ref="form" label-width="12%">
      <el-form-item label="发货时效:" prop="values">
        <PromiseConfig v-if="promiseConfList && promiseConfList.length" :promiseConfList="promiseConfList" :values="form.values" />
        <span v-else class="no-shops">暂无平台店铺</span>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSave">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import PromiseConfig from './PromiseConfig.vue';

import _ from 'lodash';
export default {
  name: 'PromiseConfigDialog',

  components: {
    PromiseConfig,
  },
  data() {
    const validatePromise = (rule, value, callback, context) => {
      let requiredList = (this.promiseConfList || []).find(item => item.requiredFlag && !context.values[item.shopId]);
      requiredList ? callback(new Error('请选择发货时效')) : callback();
    };
    return {
      opts: {},
      form: {
        values: {},
      },
      promiseConfList: [],
      visible: false,
      rules: {
        values: [{ validator: validatePromise }],
      },
    };
  },

  methods: {
    method_open(opts) {
      this.opts = opts;
      this.visible = true;
      this.promiseConfList = opts.promiseConfList;
      this.form.values = opts.values;
    },
    handleSave() {
      let _this = this;
      this.$refs.form.validate(valid => {
        if (valid) {
          _this.opts.saveFn && _this.opts.saveFn(_this.handlePromiseConfig());
          _this.handleClose();
        }
      });
    },
    handlePromiseConfig() {
      const arr = [];
      Object.keys(this.form.values).forEach(key => {
        arr.push({
          shopId: key,
          promiseId: this.form.values[key],
        });
      });
      return arr;
    },
    handleClose() {
      this.visible = false;
      this.form.values = {};
      this.promiseConfList = [];
    },
  },
};
</script>

<style lang="scss" scoped>
</style>